
window.$ = window.jQuery = require('jquery');


// JS PART
require('jquery-form');
require('jquery-ui/ui/widgets/button');
require('jquery-ui/ui/widgets/checkboxradio');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');
require('jquery-ui/ui/widgets/dialog');
require('jquery-ui/ui/widgets/progressbar');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/ui/widgets/tooltip');
// FIX focus modal redactor/jsuery ui
$.ui.dialog.prototype._focusTabbable = function(){};

window._			= require("underscore");
window.Big			= require('big.js');
window.moment		= require('moment');

require('fullcalendar');
require('intl-tel-input/build/js/utils.js');
require('intl-tel-input');
require('multiple-select');
require('timepicker');
require('qtip2');
require('jquery.maskedinput/src/jquery.maskedinput.js');
require('jquery-jcrop');
require('moment-timezone');

require('../../../node_modules/leaflet/dist/leaflet');
require('../../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine');

window.toastr = require('toastr');
window.Papa = require('papaparse');

var context = require.context('./vendor/', false, /\.js$/);
var files	= {};

context.keys().forEach(function(filename){
  files[filename] = context(filename);
});

require('jsplumb').jsPlumb.getInstance({
	// notice the 'curviness' argument to this Bezier curve.  the curves on this page are far smoother
	// than the curves on the first demo, which use the default curviness value.
	anchor		: "Perimeter",
	anchors		: [ "Perimeter" ],
	Connector	: ["Flowchart", {cornerRadius : 3}],
	DragOptions	: {cursor: "crosshair", zIndex: 2000},
	PaintStyle	: {strokeStyle: "#CACACA", lineWidth: 2},
	Endpoint	: 'Blank',
	Container	: "content_docTree"
});

window.qq = "";

require('fine-uploader/jquery.fine-uploader/jquery.fine-uploader.min.js');

var Highcharts = window.Highcharts = require('highcharts');
require('highcharts/modules/funnel')(window.Highcharts);
require('highcharts/modules/drilldown')(window.Highcharts);
require('highcharts/modules/no-data-to-display')(window.Highcharts);

window.iFrameResize		= require('iframe-resizer/js/iframeResizer.min.js');
window.CodeMirror		= require('codemirror');
window.dataTables		= require('datatables.net');
window.io 				= require('socket.io-client');


var lodash = window.lodash			= require("lodash");
window.axios = require('axios');

var setupCsrfToken = function () {
	var csrf_token = $('meta[name="saas-csrf-token"]').attr('content');
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf_token;
	return csrf_token;
};
var refreshCsrfToken = function (response) {
	// Refresh Csrf token in DOM if provided in response
	if (response.headers['x-csrf-token']) {
		$('meta[name="saas-csrf-token"]').attr('content', response.headers['x-csrf-token']);
		setupCsrfToken();
	}
};

// Add a request interceptor
window.axios.interceptors.request.use(function (config) {
	// Do something before request is sent
    // Add custom header on request for backend specific treatment
    config.headers['X-REQUESTED-WITH-AXIOS'] = 1;
    config.headers['X-Requested-With'] = "XMLHttpRequest";
	config.headers['X-CSRF-TOKEN'] = setupCsrfToken();
	return config;
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
window.axios.interceptors.response.use(function (response) {
	// Do something with response data
	refreshCsrfToken(response);
	return response;
}, function (error) {
	// Do something with response error
	return Promise.reject(error);
});

// Translation setup
import Translator from "gettext-translator";

window.translations = window.translations != undefined ? window.translations : {"domain":null,"plural-forms":"nplurals=2; plural=n > 1;","messages":[]};

window.i18n = new Translator(window.translations);